// extracted by mini-css-extract-plugin
module.exports = {"mastheadButtons":"MastheadButtons__mastheadButtons___nLBA5","useWFFonts":"MastheadButtons__useWFFonts___8sudb","tpb":"MastheadButtons__tpb___2-_6X"};